function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Group 5");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Symbols/Icons",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "icon/Fare/6.-Eksplosjonsfare",
  transform: "translate(4.000000, 4.000000)"
}, React.createElement("g", {
  id: "Group-5",
  transform: "translate(-4.000000, -4.000000)"
}, React.createElement("g", {
  id: "Group-4777"
}, React.createElement("path", {
  d: "M0.249964228,16.0083512 L16.0465171,31.8054244 L31.8433301,16.0083512 L16.0465171,0.211538211 L0.249964228,16.0083512 Z M29.3400455,16.0083512 C28.2455415,17.1028553 17.1412813,28.2076358 16.0465171,29.3024 C14.9517528,28.2076358 3.84775285,17.1028553 2.75298862,16.0083512 C3.84775285,14.913587 14.9517528,3.80932683 16.0465171,2.7145626 C17.1410211,3.80932683 28.2455415,14.913587 29.3400455,16.0083512 L29.3400455,16.0083512 Z",
  id: "Fill-4769",
  fill: "#D8232A"
}), React.createElement("path", {
  d: "M17.8921366,7.70788943 L17.462348,7.51146667 L15.2218276,13.9013203 C15.3550309,13.9489301 15.4838114,14.009548 15.6045268,14.0823935 L17.8921366,7.70788943 Z",
  id: "Fill-4771",
  fill: "#0A0B09"
}), React.createElement("path", {
  d: "M17.5851447,10.777678 L17.3642667,10.6426537 L15.6183154,14.0913691 C15.6279415,14.0970927 15.6370472,14.1030764 15.646413,14.1090602 L17.5851447,10.777678 Z",
  id: "Fill-4773",
  fill: "#0A0B09"
}), React.createElement("path", {
  d: "M15.1650341,13.8814959 L16.4923837,9.75843902 L16.2467902,9.61118699 L15.153587,13.8775935 C15.1574894,13.8786341 15.1613919,13.8801951 15.1650341,13.8814959",
  id: "Fill-4775",
  fill: "#0A0B09"
})), React.createElement("polygon", {
  id: "Fill-4778",
  fill: "#0A0B09",
  points: "15.4549073 11.1751805 15.6456065 10.8968065 15.9754927 10.5377821 15.7938992 9.94981463 15.5446634 9.94539187 15.4369561 10.2190829 15.2259642 10.1360911 15.1182569 10.6590179 15.3427772 10.7643837"
}), React.createElement("polygon", {
  id: "Fill-4779",
  fill: "#0A0B09",
  points: "17.4834732 11.4616715 17.3437659 11.657574 17.2633756 12.0655089 17.5451317 12.3098016 17.7464976 12.0655089 17.8029528 11.7892163 17.6793756 11.4590699 17.5825951 11.5610537"
}), React.createElement("path", {
  d: "M16.3224455,14.2021724 L16.2891447,14.1243837 L16.0201366,14.4173268 C16.0344455,14.4329366 16.0490146,14.4482862 16.0628033,14.4641561 L16.3224455,14.2021724 Z",
  id: "Fill-4780",
  fill: "#0A0B09"
}), React.createElement("polygon", {
  id: "Fill-4782",
  fill: "#0A0B09",
  points: "16.8485984 13.6709724 20.7205984 9.76202927 20.4978992 9.53906992 16.5717854 13.8164033 16.7765333 13.6725333"
}), React.createElement("polygon", {
  id: "Fill-4783",
  fill: "#0A0B09",
  points: "14.8938667 15.6444358 15.8928911 14.6357854 15.8205659 14.6350049"
}), React.createElement("polygon", {
  id: "Fill-4784",
  fill: "#0A0B09",
  points: "20.7095415 11.7450927 15.5401106 15.3881496 20.7095415 12.1795642"
}), React.createElement("polygon", {
  id: "Fill-4785",
  fill: "#0A0B09",
  points: "19.1052748 14.1292228 19.0829008 13.8729626 16.0416 15.310361"
}), React.createElement("polygon", {
  id: "Fill-4786",
  fill: "#0A0B09",
  points: "16.3532488 14.2741073 16.7656065 14.0847089 16.8548423 14.3966439 17.512013 13.8620098 17.8796228 13.1822049 17.3005008 13.6614244 16.8485984 13.6710504 16.7767935 13.6726114 16.5717854 13.8162211 16.2530862 14.0402211 16.2892488 14.1242537 16.3225496 14.2023024"
}), React.createElement("polygon", {
  id: "Fill-4787",
  fill: "#0A0B09",
  points: "19.9853789 13.4050602 19.8852163 13.6725073 20.8098341 13.7838569 20.1968911 13.171174"
}), React.createElement("polygon", {
  id: "Fill-4788",
  fill: "#0A0B09",
  points: "22.5255545 12.2798569 23.1494244 12.7031415 23.1382374 11.945548 22.7261398 11.2436293 22.5367415 11.8341984 22.0354081 11.8565724 21.8904976 11.967922 21.8236358 12.3912065 22.2136195 12.6141659"
}), React.createElement("polygon", {
  id: "Fill-4789",
  fill: "#0A0B09",
  points: "24.5590894 13.5168 24.4326504 13.2498732 15.3300813 15.6098081"
}), React.createElement("polygon", {
  id: "Fill-4790",
  fill: "#0A0B09",
  points: "15.6695415 15.8866732 25.6688911 14.5283642 25.6688911 14.1911935 15.6685008 15.8858927"
}), React.createElement("polygon", {
  id: "Fill-4791",
  fill: "#0A0B09",
  points: "19.3053919 16.1998569 19.4078959 16.310426 20.1969691 16.3354016 20.5133268 15.9750764 19.4037333 15.4833691 19.1089691 15.7643447 18.6872455 15.9048325 18.7868878 16.2906537 18.9591154 16.2961171"
}), React.createElement("polygon", {
  id: "Fill-4792",
  fill: "#0A0B09",
  points: "18.7998439 16.3403447 18.8125919 16.3367024 18.7985431 16.3361821"
}), React.createElement("polygon", {
  id: "Fill-4793",
  fill: "#0A0B09",
  points: "19.488 16.3965398 20.1061463 16.4389463 20.1402276 16.399922 19.4609431 16.3674016"
}), React.createElement("polygon", {
  id: "Fill-4794",
  fill: "#0A0B09",
  points: "18.7986732 16.336 18.8129821 16.3367805 19.4610472 16.3672195 20.1405919 16.3994797 24.5310959 16.6070894 24.3484618 16.4668618 20.1970472 16.3352195 19.407974 16.3102439 18.9591935 16.2961951 18.7869659 16.2907317 16.0141528 16.2027967 16.0151935 16.2043577"
}), React.createElement("path", {
  d: "M17.656013,17.0072715 L17.7054439,16.9385886 L18.1716553,17.1402146 L19.8112,17.5624585 L19.8814439,17.0848 L16.2961431,16.5829463 C16.2875577,16.6055805 16.2787122,16.6279545 16.2693463,16.6500683 L17.656013,17.0072715 Z",
  id: "Fill-4795",
  fill: "#0A0B09"
}), React.createElement("polygon", {
  id: "Fill-4797",
  fill: "#0A0B09",
  points: "17.656013 17.0072715 17.5953951 17.0913041 17.1736715 17.0132553 17.0565984 17.2258081 17.4819642 17.5416455 18.6024846 17.732865 18.6201756 17.4635967 18.4357203 17.2541659 18.1716553 17.1402146 17.7054439 16.9385886"
}), React.createElement("path", {
  d: "M18.5031024,18.3641236 L18.3719805,18.0979772 L16.1559154,16.8798959 C16.1494114,16.8916033 16.1429073,16.9030504 16.1361431,16.9144976 L18.5031024,18.3641236 Z",
  id: "Fill-4798",
  fill: "#0A0B09"
}), React.createElement("polygon", {
  id: "Fill-4800",
  fill: "#0A0B09",
  points: "15.2035902 16.4173789 15.2155577 16.4093138 14.9140293 16.1912976"
}), React.createElement("g", {
  id: "Group-4805",
  transform: "translate(15.869919, 16.910569)",
  fill: "#0A0B09"
}, React.createElement("path", {
  d: "M2.69981138,2.13557073 L2.82104715,2.01459512 L0.195226016,0.113847154 C0.185339837,0.128156098 0.175453659,0.142204878 0.165307317,0.156253659 L2.69981138,2.13557073 Z",
  id: "Fill-4801"
}), React.createElement("path", {
  d: "M2.03077724,1.95129756 L1.90954146,1.67734634 L0.0436552846,0.307850407 C0.0361105691,0.315915447 0.0288260163,0.323980488 0.0215414634,0.332305691 L2.03077724,1.95129756 Z",
  id: "Fill-4803"
})), React.createElement("polygon", {
  id: "Fill-4806",
  fill: "#0A0B09",
  points: "12.132787 18.2195772 12.321665 18.4292683 12.5313561 18.3350894 12.6364618 18.439935 12.8461528 18.3140163 12.9301854 18.0306992 12.7306407 17.9047805 12.4254699 17.9047805 12.1754537 18.1339837"
}), React.createElement("g", {
  id: "Group-4813",
  transform: "translate(10.146341, 16.650407)",
  fill: "#0A0B09"
}, React.createElement("path", {
  d: "M0.0562471545,2.88049431 L0.276604878,3.09018537 L2.02932033,1.4836813 L2.27933659,1.25447805 L3.03901138,0.558022764 C3.02886504,0.546055285 3.0187187,0.534087805 3.00883252,0.522120325 L0.0562471545,2.88049431 Z",
  id: "Fill-4807"
}), React.createElement("path", {
  d: "M0.255531707,1.55866016 L0.265938211,1.69498537 L2.7926374,0.207635772 C2.78977561,0.20243252 2.78717398,0.196969106 2.7843122,0.191505691 L0.255531707,1.55866016 Z",
  id: "Fill-4809"
}), React.createElement("path", {
  d: "M1.17869268,0.541112195 L1.15761951,0.698510569 L2.77036748,0.165697561 C2.76282276,0.151388618 2.75527805,0.137079675 2.74825366,0.122510569 L1.17869268,0.541112195 Z",
  id: "Fill-4811"
})), React.createElement("polygon", {
  id: "Fill-4814",
  fill: "#0A0B09",
  points: "10.832052 17.6215415 10.832052 17.4326634 10.2760846 17.4011837 10.6012878 17.7159805"
}), React.createElement("polygon", {
  id: "Fill-4815",
  fill: "#0A0B09",
  points: "9.40529431 18.4188878 9.09049756 18.2196033 8.97524553 18.5970992 9.29576585 19.0380748 9.31085528 19.0586276 9.41596098 18.7649041 9.61498537 18.7544976 9.74090407 18.6181724 9.80386341 18.4188878 9.49973333 18.3033756"
}), React.createElement("g", {
  id: "Group-4820",
  transform: "translate(6.504065, 16.390244)",
  fill: "#0A0B09"
}, React.createElement("path", {
  d: "M1.68426667,1.31522602 L1.65278699,1.47262439 L6.35652683,0.311518699 C6.35262439,0.302933333 6.34898211,0.293827642 6.34533984,0.285242276 L1.68426667,1.31522602 Z",
  id: "Fill-4816"
}), React.createElement("path", {
  d: "M0.0687609756,0.811733333 L0.0583544715,0.948058537 L6.27754146,0.108513821 C6.27676098,0.10539187 6.27572033,0.102530081 6.27467967,0.0994081301 L0.0687609756,0.811733333 Z",
  id: "Fill-4818"
})), React.createElement("polygon", {
  id: "Fill-4821",
  fill: "#0A0B09",
  points: "8.88075447 16.6145041 8.88075447 16.7404228 9.78299837 16.8241951 9.20595772 16.3733333"
}), React.createElement("polygon", {
  id: "Fill-4822",
  fill: "#0A0B09",
  points: "11.2202146 16.1738146 11.1975805 16.1332293 10.617678 16.1098146 10.4964423 16.3101398 10.832052 16.5515707 11.1991415 16.6145301 11.3146537 16.425652 11.5454179 16.425652 11.5207024 16.1462374 11.3201171 16.1381724"
}), React.createElement("polygon", {
  id: "Fill-4823",
  fill: "#0A0B09",
  points: "11.4382829 16.0961301 11.516852 16.1013333 11.5139902 16.0690732"
}), React.createElement("polygon", {
  id: "Fill-4824",
  fill: "#0A0B09",
  points: "10.6574049 16.0446179 11.1668033 16.078439 11.1150309 15.9850407 10.7063154 15.9639675"
}), React.createElement("polygon", {
  id: "Fill-4825",
  fill: "#0A0B09",
  points: "11.516722 16.1011512 11.4381528 16.095948 11.1670634 16.0779967 10.6574049 16.0444358 8.16738862 15.8802732 8.29330732 16.0165984 10.6176 16.1099967 11.1975024 16.1331512 11.3202992 16.1380943 11.5206244 16.1461593 12.7142504 16.1940293 12.7194537 16.1805008"
}), React.createElement("polygon", {
  id: "Fill-4826",
  fill: "#0A0B09",
  points: "12.7930537 16.1975154 13.2556228 16.2154667 12.7326959 16.1816455"
}), React.createElement("polygon", {
  id: "Fill-4827",
  fill: "#0A0B09",
  points: "10.9159545 15.4919805 10.7585561 15.6283057 13.2449301 16.0164683"
}), React.createElement("polygon", {
  id: "Fill-4828",
  fill: "#0A0B09",
  points: "11.6398049 15.0093789 11.6816911 15.1142244 13.339187 15.9116228"
}), React.createElement("path", {
  d: "M12.0069724,14.6632846 L12.1014114,14.8521626 L12.7375089,15.2793496 C12.7421919,15.260878 12.7466146,15.2424065 12.7515577,15.2244553 L12.0069724,14.6632846 Z",
  id: "Fill-4829",
  fill: "#0A0B09"
}), React.createElement("polygon", {
  id: "Fill-4831",
  fill: "#0A0B09",
  points: "13.1838439 15.579135 13.5384455 15.8169236 13.2197463 15.5770537"
}), React.createElement("path", {
  d: "M15.5426081,15.7858081 L15.5426081,16.1890602 L15.2153236,16.4091577 L15.2036163,16.4172228 L14.9431935,16.5923122 L14.1260228,15.8948163 L13.5484618,16.3961496 L12.7929496,16.1973854 L12.7325919,16.1815154 L12.7203642,16.1781333 L12.7193236,16.1804748 L12.7141203,16.1942634 L12.7076163,16.211174 C12.7250472,16.3066537 12.7492423,16.3995317 12.7786407,16.489548 C12.7796813,16.4926699 12.780722,16.4955317 12.7817626,16.4986537 C12.8017951,16.5590114 12.8244293,16.6178081 12.8494049,16.6753041 C12.8530472,16.6841496 12.8566894,16.6929951 12.8605919,16.7018407 C12.8715187,16.7257756 12.8827057,16.7494504 12.894413,16.772865 C12.9016976,16.7874341 12.9092423,16.8017431 12.916787,16.816052 C12.9212098,16.8246374 12.9258927,16.8332228 12.9305756,16.8418081 C12.9334374,16.8472715 12.9362992,16.852735 12.939161,16.8579382 C13.0016,16.9705886 13.0741854,17.0754341 13.1550959,17.1724748 C13.1649821,17.1844423 13.1751285,17.1966699 13.1852748,17.2083772 C13.5286894,17.6004423 14.0146732,17.8455154 14.5539902,17.8455154 C15.0769171,17.8455154 15.5501528,17.6147512 15.891226,17.2427187 C15.8987707,17.2346537 15.9060553,17.2265886 15.9133398,17.2182634 C15.9562667,17.1698732 15.996852,17.1194016 16.0350959,17.0668488 C16.0452423,17.0528 16.0553886,17.0384911 16.0650146,17.0244423 C16.0897301,16.9885398 16.113665,16.9521171 16.136039,16.9143935 C16.1428033,16.9029463 16.1493073,16.8914992 16.1558114,16.8797919 C16.1979577,16.8061659 16.2362016,16.729678 16.2692423,16.6500683 C16.2786081,16.6279545 16.2874537,16.6055805 16.296039,16.5829463 C16.3176325,16.5259707 16.3374049,16.4676943 16.3540553,16.4083772 L16.076722,16.3089951 L16.0150634,16.2044098 L16.0142829,16.2028488 L15.9677138,16.1234992 L15.6695675,15.8867512 L15.6685268,15.8857106 L15.5426081,15.7858081 Z",
  id: "Fill-4832",
  fill: "#0A0B09"
}), React.createElement("path", {
  d: "M14.5538341,13.780761 C13.7038829,13.780761 12.985574,14.3890211 12.7516878,15.2244033 C12.7464846,15.2426146 12.7420618,15.260826 12.7373789,15.2792976 C12.7352976,15.2884033 12.7326959,15.2972488 12.7306146,15.3060943 L12.9928585,15.5896715 L13.1835577,15.5790049 L13.2194602,15.5769236 L13.766322,15.5459642 L14.5291187,15.9273626 L14.9651512,15.4044358 L14.7689886,14.9249561 L15.3681431,14.9902569 L15.4555577,14.6307122 L15.8205659,14.6348748 L15.8928911,14.6356553 L16.1965008,14.6392976 C16.1564358,14.5781593 16.1114276,14.5198829 16.0627772,14.4642081 C16.0489886,14.4483382 16.0346797,14.4329886 16.0201106,14.4173789 C15.9108423,14.3005659 15.7846634,14.1970211 15.6462569,14.1090862 C15.6371512,14.1031024 15.6277854,14.0971187 15.6184195,14.0913951 C15.6137366,14.0882732 15.6090537,14.0854114 15.6043707,14.0822894 C15.4836553,14.0097041 15.3548748,13.948826 15.2219317,13.9012163 C15.2029398,13.894452 15.1842081,13.8876878 15.1649561,13.8814439 C15.1613138,13.8801431 15.1574114,13.8785821 15.1537691,13.8775415 C14.9581268,13.8148423 14.7544195,13.780761 14.5538341,13.780761",
  id: "Fill-4834",
  fill: "#0A0B09"
}))));

var SvgExplosionIcon = function SvgExplosionIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgExplosionIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/explosionIcon.ddb34e9f.svg";
export { ForwardRef as ReactComponent };